<template>
  <div>
    <v-dialog
      v-model="this.visible"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="$emit('onClose')">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Copia Movimenti</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-menu
                  ref="menuDataDa"
                  :close-on-content-click="true"
                  v-model="menuDataDa"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="computedDataDaFormatted"
                    label="Da (Data)"
                    prepend-icon="event"
                    @blur="
                      dataDa = parseDateGui2AnnoMeseGiornoTrattino(
                        computedDataDaFormatted
                      )
                    "
                    required
                  >
                  </v-text-field>
                  <v-date-picker
                    v-model="dataDa"
                    :allowed-dates="allowedDates"
                    no-title
                    locale="it-IT"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-menu
                  ref="menuDataA"
                  :close-on-content-click="true"
                  v-model="menuDataA"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="computedDataAFormatted"
                    label="A (Data)"
                    prepend-icon="event"
                    @blur="
                      dataA = parseDateGui2AnnoMeseGiornoTrattino(
                        computedDataAFormatted
                      )
                    "
                    required
                  >
                  </v-text-field>
                  <v-date-picker
                    v-model="dataA"
                    :allowed-dates="allowedDates"
                    no-title
                    locale="it-IT"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" flat @click="clearFilter">Pulisci</v-btn>
          <v-btn color="primary" flat @click="copia">Copia</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import utilities from "../../utilitiesMixin.js";

export default {
  props: {
    visible: {
      type: Boolean,
    },
  },
  /*
  watch: {
    'visible': function (val, oldVal) {
      console.log(oldVal)
      if (val) {
        this.clearFilter();
      }
    },    
  },
  */
  data(vm) {
    return {
      dataDa: vm.dataCorrente(), // formato YYYY-MM-DD
      dataA: vm.dataCorrente(), // formato YYYY-MM-DD
      dataDaFormatted: vm.parseDate2Gui(vm.dataCorrente()), // formato DD/MM/YYYY
      dataAFormatted: vm.parseDate2Gui(vm.dataCorrente()), // formato DD/MM/YYYY
      menuDataDa: false,
      menuDataA: false,
    };
  },
  computed: {
    computedDataDaFormatted() {
      return this.parseDate2Gui(this.dataDa);
    },
    computedDataAFormatted() {
      return this.parseDate2Gui(this.dataA);
    },
  },
  mixins: [utilities],
  methods: {
    copia() {
      const dataDa_ms = this.parseDate2DBFromAnnoMeseGiornoTrattino(
        this.dataDa
      );
      const dataA_ms = this.parseDate2DBFromAnnoMeseGiornoTrattino(this.dataA);
      const movimenti = this.$store.getters.getMovimentiSelezionati;
      if (!movimenti || movimenti.lenght < 1) {
        return;
      }
      const parametri = {
        parcheggio: true,
        movimenti: movimenti,
        dataDa: dataDa_ms,
        dataA: dataA_ms,
      };

      this.$emit("onClose");
      this.$store.dispatch("showWaitDialog");
      axios
        .post("/movimento/copia", parametri)
        .then((res) => {
          console.log(res);
          // eslint-disable-next-line
          this.$store.dispatch("clearMovimentiSelezionati");
          this.$store.dispatch("fetchMovimenti").then(() => {
            this.$store.dispatch("hideWaitDialog");
            this.$router.push({
              name: "movimenti",
            });
          });
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.log(error);
          this.$store.dispatch("hideWaitDialog");
          this.$store.dispatch("handleError", error.response.data);
        });
      /**/
    },
    clearFilter() {
      this.dataDa = this.dataCorrente();
      this.dataA = this.dataCorrente();
    },
    allowedDates() {
      return true;
    },
  },
};
</script>